import { queryOptions, useQuery } from '@tanstack/react-query';

import { patientKeys } from './query-key-factory';

import { QueryConfig } from '@/lib/react-query';
import { supabase } from '@/lib/supabase-client';
import { logger } from '@/logger';

export type Patient = Awaited<ReturnType<typeof getPatient>>;
export const getPatient = async ({ pid }: { pid: string }) => {
  const { data, error } = await supabase
    .from('patients')
    .select(
      `id,
      practician:users(*),
      name,
      age,
      gender,
      deleted_at
      `,
    )
    .eq('id', pid)
    .single();

  if (error) {
    logger.error('Error fetching patient', {
      errorMessage: error,
      pid,
    });
    throw error;
  }

  return data;
};

const getPatientQueryOptions = (pid: string) => {
  return queryOptions({
    queryKey: patientKeys.detail(pid),
    queryFn: () => getPatient({ pid }),
  });
};

type UsePatientOptions = {
  pid: string;
  queryConfig?: QueryConfig<typeof getPatientQueryOptions>;
};

export const usePatient = ({ pid, queryConfig }: UsePatientOptions) => {
  return useQuery({
    ...getPatientQueryOptions(pid),
    ...queryConfig,
  });
};
